"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as a } from "react";
import e from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.56 2h-3.12a.933.933 0 0 0-.947.933v6.56H6.067a.773.773 0 0 0-.547 1.334l5.947 5.946a.76.76 0 0 0 1.066 0l5.947-5.946a.787.787 0 0 0-.56-1.334h-3.413v-6.56A.933.933 0 0 0 13.56 2M22 21.067v-4.4a.933.933 0 0 0-.933-.92h-5.734l-1.92 1.893a1.987 1.987 0 0 1-2.826 0l-1.92-1.92H2.933a.934.934 0 0 0-.933.947v4.4c0 .515.418.933.933.933h18.134a.933.933 0 0 0 .933-.933",
        clipRule: "evenodd"
      }
    )
  }
), h = a(t);
export {
  h as Download,
  h as default
};
